import { LoadStatus } from '@capital-access/common/utils';

export const TemplateExportInitialState = {
  exportData: [],
  loaderStatus: LoadStatus.Pristine,
  exportStatus: LoadStatus.Pristine,
  addListDrawerOpened: false,
  selectedList: [],
  ownershipAnalysisSelectedList: [],
  peerOwnershipSelectedList: [],
  commentSectionDrawerState: {
    isOpened: false,
    selectedListItem: null
  },
  filterActivitiesDrawerState: {
    isOpened: false,
    selectedListItem: null,
    companyContactLoadStatus: LoadStatus.Pristine,
    companyContacts: []
  },
  showExportWarning: true,
  showSelectWarning: true,
  exportBnySecurityId: -1,
  exportBnyPrSecurityId: -1,
  exportOwnershipAnalysisSecurityId: -1,
  exportPeerOwnershipSecurityId: -1,
  exportBnyReportTime: new Date(),
  exportItineraryComments: [],
  exportOwnershipAnalysisPeerSecurity: {} as Record<string, number[]>,
  exportOwnershipAnalysisPeerList: {} as Record<string, number>,
  includeOwnershipAnalysis: false,
  exportSucceeded: false,
  exportPeerOwnershipComment: null
};
